import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
    selector: "fui-time-selector",
    templateUrl: "./time-selector.component.html",
    styleUrls: ["./time-selector.component.scss"]
})
export class FUITimeSelectorComponent {
    @Output() public valueChange: EventEmitter<Date> = new EventEmitter<Date>();

    hour: number;
    minute: number;
    hourDial: boolean = true;

    private isMouseDown: boolean = false;
    private _value: Date;

    constructor() {
    }

    @Input()
    set value(value: Date) {
        this._value = value;
        this.hour = value ? value.getHours() : 0;
        this.minute = value ? value.getMinutes() : 0;
    }

    get value(): Date {
        return this._value;
    }

    hour12(hour: number): number {
        return (hour % 12) || 12;
    }

    get pm(): boolean {
        return this.hour >= 12;
    }

    set pm(pm: boolean) {
        if (pm !== this.pm) {
            this.hour += pm ? 12 : -12;
        }
    }

    dialNumber(position: number): number {
        return this.hourDial ? this.hour12(position) : (position * 5);
    }

    mouseDown(event: MouseEvent): void {
        if (event.currentTarget instanceof HTMLElement) {
            this.adjust(event.currentTarget, event.pageX, event.pageY);
            this.isMouseDown = true;
        }
        event.stopPropagation();
    }

    mouseUp(): void {
        this.isMouseDown = false;
        event.stopPropagation();
    }

    mouseMove(event: MouseEvent): void {
        if (this.isMouseDown && event.currentTarget instanceof HTMLElement) {
            this.adjust(event.currentTarget, event.pageX, event.pageY);
        }
        event.stopPropagation();
    }

    touch(event: TouchEvent): void {
        if (event.currentTarget instanceof HTMLElement) {
            this.adjust(event.currentTarget, event.touches[0].pageX, event.touches[0].pageY);
        }
        event.stopPropagation();
    }

    adjust(element: HTMLElement, eventX: number, eventY: number): void {
        const rect: DOMRect = element.getBoundingClientRect();
        let rad: number = Math.atan2(eventY - rect.top - rect.height / 2, eventX - rect.left - rect.width / 2) + Math.PI / 2;
        if (rad < 0) {
            rad += Math.PI * 2;
        }
        if (this.hourDial) {
            this.hour = Math.round(rad * (6 / Math.PI) + (this.pm ? 12 : 0));
        } else {
            this.minute = Math.round(rad * (30 / Math.PI));
        }
    }

    accept() {
        this._value = new Date();
        this._value.setHours(this.hour);
        this._value.setMinutes(this.minute);
        this.valueChange.next(this._value);
    }

    public focus(): void {
    }
}
